import { Component, OnInit, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { facingModeEnum } from '../../../mp-camera/mp-camera.component';

@Component({
    selector: 'app-wlc-cameral-modal',
    templateUrl: './wlc-cameral-modal.component.html',
    styleUrls: ['./wlc-cameral-modal.component.scss'],
})
export class WlcCameralModalComponent implements OnInit {
    modalData: any;
    callback: any;
    facingMode: string = facingModeEnum.environment;
    readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

    constructor(public modalService: NzModalRef) {}

    ngOnInit(): void {
        this.modalService.componentInstance = { ...this.modalService.componentInstance, ...this.nzModalData };
        this.modalData = this.modalService.componentInstance.data;
        this.callback = this.modalService.componentInstance.callback;
    }
}
